/**
 * @typedef WorkerStatuses
 * @property {'lead'} LEAD Лид - не подходит ни под один из статусов ниже
 * @property {'registred'} REGISTERED Зарегистрирован (авторизовался на сайте app.mygig.ru или в приложении)
 * @property {'moderation'} MODERATION Модерация (паспорт загружен, модерация не пройдена)
 * @property {'uploaded'} UPLOADED Паспорт загружен (паспорт загружен, модерация пройдена успешно)
 * @property {'ready'} READY Готов к работе (подтверждён паспорт, подтверждён статус самозанятого)
 * @property {'booked'} BOOKED Бронировал (есть 1 и более смена в статусах всех, кроме cancelled)
 * @property {'worked'} WORKED Работал (есть 1 и более смен в статусе confirmed)
 */

/**
 * @type {Readonly<WorkerStatuses>}
 */
const WORKER_STATUSES = Object.freeze({
  LEAD: 'lead',
  REGISTERED: 'registred',
  MODERATION: 'moderation',
  UPLOADED: 'uploaded',
  READY: 'ready',
  BOOKED: 'booked',
  WORKED: 'worked',
});

module.exports = {
  WORKER_STATUSES,
};
